import HappyGirl from "@/ui/Icons/HappyGirl";
import { FC, useEffect, useState } from "react";
import { useRouter } from "next/router";

export default function CookingDone() {
  const router = useRouter();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setTimeout(() => {
      router.push("/");
    }, 3000);

    const countdownTimer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(countdownTimer);
    };
  }, []);

  return (
    <div className="h-screen flex flex-col justify-center max-w-xl items-center px-4 gap-y-5">
      <div className={"flex justify-center"}>
        <HappyGirl />
      </div>
      <h2 className="font-semibold text-3xl text-center">Bon appétit!</h2>
      <p className="text-lg font-normal text-center text-[#343233]">
        Enjoy your delicious creation and have a wonderful dinner
      </p>
      <p className="text-gray-700">
        Redirecting to home in {countdown} seconds
      </p>
    </div>
  );
}
